module.exports = __webpack_public_path__ + "media/categories/90-b23d139a.png";